require('./componentes/header');


import { Fancybox } from "@fancyapps/ui";

window.Fancybox = Fancybox;


Fancybox.bind('[data-fancybox="Producto"]', {
    Images: {
        // Permite que el usuario haga zoom con la rueda del ratón
        Panzoom: {
            maxScale: 2, // Define qué tanto se puede ampliar (2 = 200%)
        },
        // Si quieres que al hacer clic la imagen se amplíe al máximo de una vez
        initialSize: "fit",
    },
    // Opcional: añade un botón de zoom en la barra de herramientas
    Toolbar: {
        display: {
            left: ["infobar"],
            middle: [],
            right: ["iterateZoom", "close"],
        },
    },
});
